import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Input from '@prism/input';

class PrismSearch extends React.PureComponent {
    static propTypes = {
        id: PropTypes.string,
        name: PropTypes.string,
        className: PropTypes.string,
        inputClassName: PropTypes.string,
        placeholder: PropTypes.string,
        size: PropTypes.string,
        disabled: PropTypes.bool,
        onValueChange: PropTypes.func.isRequired,
        onSubmit: PropTypes.func.isRequired
    };

    static defaultProps = {
        placeholder: 'Enter search criteria',
        disabled: false
    };

    handleValueChange = (e) => {
        this.props.onValueChange(e.target.value || '');
    }

    handleSubmit = () => {
        this.props.onSubmit();
    }

    handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            this.handleSubmit();
        }
    }

    render() {
        const {
            id,
            name,
            className,
            inputClassName,
            placeholder,
            size,
            disabled,
            value
        } = this.props;

        const containerClassName = classNames(
            'prism-sandbox',
            'prism-search-control',
            className
        );

        const elementClassName = classNames(
            'prism-input',
            inputClassName
        );

        return (
            <div className={containerClassName}>
                <Input.Interactive id={id}
                    name={name}
                    className={elementClassName}
                    placeholder={placeholder}
                    type="text"
                    iconRight='icon prism-icon-search prism-search-control__icon'
                    size={size}
                    value={value}
                    onClickRight={this.handleSubmit}
                    onChange={this.handleValueChange}
                    onKeyPress={this.handleKeyPress}
                    disabled={disabled} />
            </div>
        );
    }
}

export default PrismSearch;
